export default function postPlanReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'POST_PLAN_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'POST_PLAN_ERROR':
            return {...state, ...{error: action.error}};

        case 'POST_PLAN_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}